import React, { Fragment } from "react";
import { Divider, Select } from "antd";
import { Checkbox } from "@mui/material";
import {
    AvailableProductCommission,
    AvailableProductsAndCommissionsResponse,
} from "../../addProduct.models";
import styles from "./productSelection.module.css";
import { ErrorSection } from "../../../../../../../../../../../../../../../../Components/errorSection/errorSection.index";

export type ProductSelections = Record<string, string | null>;

interface IProductSelectionProps {
    products: AvailableProductsAndCommissionsResponse[];
    selections: ProductSelections;
    assignedProductUids: Set<string>;
    onToggle: (productUid: string, checked: boolean) => void;
    onCommissionChange: (productUid: string, commissionUid: string) => void;
    fetchError?: boolean;
    onRetry?: () => void;
}

export const ProductSelection = ({
    products,
    selections,
    assignedProductUids,
    onToggle,
    onCommissionChange,
    fetchError,
    onRetry,
}: IProductSelectionProps) => {
    const renderProductContent = () => {
        if (fetchError && onRetry) {
            return <ErrorSection handleClick={onRetry} />;
        }

        if (!products.length) {
            return <p className={styles.emptyText}>No products available</p>;
        }

        return products.map((product, index) => {
            const isAssigned = assignedProductUids.has(product.productUid);
            const isSelected = product.productUid in selections;
            const commissionUid = selections[product.productUid] ?? null;

            return (
                <Fragment key={product.productUid}>
                    <div className={styles.productItem}>
                        <div className={styles.checkboxCtn}>
                            <Checkbox
                                className={styles.checkbox}
                                checked={isSelected}
                                disabled={isAssigned}
                                onChange={(e) =>
                                    onToggle(product.productUid, e.target.checked)
                                }
                            />
                            <h5 className={styles.productName}>{product.productName}</h5>
                        </div>
                        {isSelected && (
                            <Select
                                prefix={
                                    <span className={styles.commissionPrefix}>
                                        Level:
                                    </span>
                                }
                                className={styles.select}
                                classNames={{
                                    placeholder: styles.selectPlaceholder,
                                    input: styles.selectInput,
                                }}
                                placeholder="Select"
                                value={commissionUid}
                                disabled={isAssigned}
                                onChange={(value) =>
                                    onCommissionChange(product.productUid, value)
                                }
                                options={product.productCommissions.map(
                                    (commission: AvailableProductCommission) => ({
                                        label: commission.commissionName,
                                        value: commission.commissionUid,
                                    })
                                )}
                            />
                        )}
                    </div>
                    {index < products.length - 1 && (
                        <Divider className={styles.divider} />
                    )}
                </Fragment>
            );
        })
    }

    return (
        <div className={styles.outerCtn}>
            <h5 className={styles.title}>Select Products & Commission Level</h5>
            <div className={styles.productCtn}>
                {renderProductContent()}
            </div>
        </div>
    );
};
